/**
 * Layout Component
 * Main layout wrapper for investor relations pages
 * 
 * Includes:
 * - Global styles
 * - Header with navigation
 * - Main content area
 * - Footer
 */
import React from 'react'
import { Global, css } from '@emotion/react'
import styled from '@emotion/styled'
import Header from './Header'
import Footer from './Footer'
import { LangKey } from '../types'

interface LayoutProps {
  children: React.ReactNode
  langKey: LangKey
  fluid?: boolean
  currentPath?: string
}

const globalStyles = css`
  html, body {
    margin: 0;
    padding: 0;
  }
  body {
    height: 100%;
    width: 100%;
    overflow: auto;
    font-family: 微软雅黑, 'Microsoft YaHei', sans-serif;
  }
  main {
    padding-top: 120px;
  }
  @media (max-width: 767px) {
    main {
      padding-top: 76px;
    }
  }
  a {
    text-decoration: none;
  }
  * {
    box-sizing: border-box;
  }
`

const MainContent = styled.main<{ fluid?: boolean }>`
  padding-top: 120px;
  min-height: calc(100vh - 140px);
  max-width: ${({ fluid }) => (fluid ? '100%' : '1200px')};
  margin: 0 auto;

  @media (max-width: 767px) {
    padding-top: 76px;
  }
`

const Layout: React.FC<LayoutProps> = ({ children, langKey, fluid = false, currentPath = '/' }) => {
  return (
    <>
      <Global styles={globalStyles} />
      <Header langKey={langKey} isFixed={true} currentPath={currentPath} />
      <MainContent fluid={fluid}>
        {children}
      </MainContent>
      <Footer />
    </>
  )
}

export default Layout
